const cache = new Map<string, { token: string; timestamp: number }>();
const TTL = 30 * 60 * 1000;

export const biTokenCache = {
	get: (key: string) => {
		const entry = cache.get(key);
		if (!entry || Date.now() - entry.timestamp > TTL) {
			cache.delete(key);
			return null;
		}
		return entry.token;
	},

	set: (key: string, token: string) => {
		cache.set(key, { token, timestamp: Date.now() });
	},

	clear: () => cache.clear(),
};
